import Base from "./Base"
import ViewSelector from "./common/GridIconGenerator"
import PdfType from "./common/PdfType"
import {
    Alert,
    Breadcrumb,
    Row,
    Col
} from "react-bootstrap"
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css';
import { useDropzone, } from 'react-dropzone'
import { useSelector, useDispatch } from "react-redux"
import {
    uploadFile,
    setFileUploadCount,
    getFiles,
    setCurrentPage,
    resetUploadDetails,
    showEgIcon,
    showEgTable,
    updateEgm,
    resetStore,
    resetCountDetails,
    deleteFile
} from "../slices/fileUploadReducer"
import { useParams, useNavigate, NavLink, useSearchParams } from "react-router-dom"
import { useEffect, useState } from "react"
import ListView from "./common/ListView"
import { TABLE_HEADERS, EGM_TABLE_HEADERS, successStatusIcons } from "../constants/file-uploads"
import PaginationComponent from "./common/Pagination"
import { Modal, Button } from "react-bootstrap"
import DocViewer, { PDFRenderer } from 'react-doc-viewer'
import EgmTable from "./files/EgmTable"
import { setScreenView } from "../slices/commonReducer"
import useCheckAuthorization from "../hooks/checkAuthorization"
import { CRUD_PERMISSIONS } from "../constants/user"
import Loader from "./common/Loader";
import EgmHeaders from "./common/EgmHeaders";
import FolderListModal from "./common/importBills/FolderListModal"
import ImportDrawer from "./common/importBills/ImportDrawer"
import useSidebar from "../hooks/useSidebar";
import { RiCloseLine } from 'react-icons/ri'; 
export default function FileUpload() {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const [searchParams] = useSearchParams();
    const [filter, setFilter] = useState(0)
    const [showPdf, setShowPdf] = useState(false)
    const [pdfUrl, setPdfUrl] = useState(null)
    // Add state for validation messages
    const [validationAlert, setValidationAlert] = useState({ show: false, message: '', type: 'warning' })
    const { collapse, expand, isSidebarCollapsed } = useSidebar();

    const {
        data,
        client_id,
        total_files_uploaded,
        total_files_uploaded_failed,
        total_upload_file_count,
        upload_process_status,
        total_count,
        current_page,
        eg_table_open,
        success,
        error,
        successMsg,
        loading
    } = useSelector(state => state.files);
    const { gridView } = useSelector(state => state.common)

    const uploadPermission = useCheckAuthorization(CRUD_PERMISSIONS.files.upload_files)
    const { folder_id } = useParams();
    const [importedData, setImportedData] = useState(null);
    const [folderListModalOpen, setFolderListModalOpen] = useState(false);
    const handleImportResponse = (data) => {
        setImportedData(data);
        setFolderListModalOpen(true)
    };
    // Function to validate if file is PDF
    const isPdfFile = (file) => {
        // Check by MIME type
        if (file.type === 'application/pdf') {
            return true;
        }

        // Fallback: Check by file extension
        const fileName = file.name.toLowerCase();
        return fileName.endsWith('.pdf');
    }
    const onSubmitSuccess = () => {
        dispatch(getFiles({ folder_id, page: 1, filter: 0 }))
    };
    // Enhanced handleFile function with PDF validation
    const handleFile = (files) => {
        // Filter only PDF files
        const pdfFiles = files.filter(file => isPdfFile(file));
        const rejectedFiles = files.filter(file => !isPdfFile(file));

        // Show validation message if some files were rejected
        if (rejectedFiles.length > 0) {
            const rejectedNames = rejectedFiles.map(file => file.name).join(', ');
            setValidationAlert({
                show: true,
                message: `${rejectedFiles.length} file(s) rejected (only PDF files are allowed): ${rejectedNames}`,
                type: 'warning'
            });

            // Auto-hide alert after 5 seconds
            setTimeout(() => {
                setValidationAlert({ show: false, message: '', type: 'warning' });
            }, 5000);
        }

        // Proceed with PDF files only
        if (pdfFiles.length > 0) {
            dispatch(setFileUploadCount(pdfFiles.length));
            pdfFiles.forEach((file, index) => {
                setTimeout(() => dispatch(uploadFile({ folder_id, file })), 1000 * (index + 1))
            });

            // Show success message if some PDFs were accepted
            if (rejectedFiles.length > 0) {
                setTimeout(() => {
                    setValidationAlert({
                        show: true,
                        message: `${pdfFiles.length} PDF file(s) accepted for upload.`,
                        type: 'success'
                    });
                    setTimeout(() => {
                        setValidationAlert({ show: false, message: '', type: 'success' });
                    }, 3000);
                }, 5100);
            }
        } else if (rejectedFiles.length > 0) {
            // All files were rejected
            setValidationAlert({
                show: true,
                message: 'No valid PDF files selected. Please choose PDF files only.',
                type: 'danger'
            });
            setTimeout(() => {
                setValidationAlert({ show: false, message: '', type: 'danger' });
            }, 5000);
        }
    }

    useEffect(() => {
        const data = {
            folder_id,
            page: current_page
        }

        if (searchParams.get('file_name')) {
            data['q'] = searchParams.get('file_name')
        }

        dispatch(getFiles(data))
        dispatch(showEgIcon(true))
        return () => {
            dispatch(showEgIcon(false))
            dispatch(resetUploadDetails());
            dispatch(resetCountDetails())
            dispatch(resetStore('all'))
            dispatch(setScreenView('grid'))
        }
    }, [])

    useEffect(() => {
        if (eg_table_open) {
            dispatch(getFiles({ folder_id, page: current_page, filter: 1 }))
            dispatch(setScreenView(eg_table_open ? 'egm' : 'grid'))
        }
    }, [eg_table_open])

    useEffect(() => {
        if (upload_process_status === 1) {
            dispatch(getFiles({ folder_id, page: current_page }))
            if (total_upload_file_count === total_files_uploaded)
                dispatch(resetUploadDetails())
        }
    }, [upload_process_status, total_files_uploaded])

    const handlePagination = (number) => {
        dispatch(setCurrentPage(number))
        const filter_type = gridView === 'egm' ? 1 : 0
        dispatch(getFiles({ folder_id, page: number, filter: filter_type }));
    }

    const {
        getRootProps,
        getInputProps,
        open
    } = useDropzone({
        noClick: true,
        noKeyboard: true,
        noDrag: !uploadPermission,
        noDragEventsBubbling: true,
        accept: {
            'application/pdf': ['.pdf']  // Accept only PDF files
        },
        onDropAccepted: (files) => handleFile(files),
        onDropRejected: (fileRejections) => {
            // Handle rejected files
            const rejectedNames = fileRejections.map(rejection => rejection.file.name).join(', ');
            setValidationAlert({
                show: true,
                message: `Files rejected (only PDF files are allowed): ${rejectedNames}`,
                type: 'danger'
            });
            setTimeout(() => {
                setValidationAlert({ show: false, message: '', type: 'danger' });
            }, 5000);
        }
    })

    const handleFilterChange = (val) => {
        setFilter(val)
        dispatch(getFiles({ folder_id, page: current_page, filter: val }));
    }

    const handlePdfClick = (url) => {
        const pdf = [{ uri: url, fileType: 'pdf' }];
        collapse();
        setPdfUrl(pdf)
        setShowPdf(true)
    }

    const handleClose = () => {
        expand();
        setShowPdf(false)
    }

    const handleDelete = (id, folder) => {
        dispatch(deleteFile({ id, folder_id: folder,filter:filter }))
    }

    const handleEgmSubmit = (data) => {
        const { id, folder, egm_number, egm_date } = data;
        if (id && folder && egm_number && egm_date)
            dispatch(updateEgm({ id, folder_id: folder, data: { egm_number, egm_date } }))
    }

    const handleCloseEgmTable = () => {
        dispatch(showEgTable(false))
        dispatch(getFiles({ folder_id, page: current_page, filter: 0 }))
        dispatch(setScreenView('grid'))
    }

    const handleBackToFolders = () => {
        dispatch(setScreenView('grid'))
        navigate(-1)
    }

    const handleSummaryClose = () => {
        dispatch(resetUploadDetails());
        dispatch(getFiles({ folder_id, page: current_page }))
    }

    return (
        <BlockUi tag="div" className="pv-blackdrop" blocking={upload_process_status === 1} message="Uploading File! Please wait. Do not refresh or press back button">
            <Base sticky_footer={false} hideDatepicker={true}>
                {loading ? (
                    <Loader />
                ) : (
                    <>
                        <EgmHeaders headerType="statement3"></EgmHeaders>
                        <Row className="mt-4 mb-4 d-flex justify-content-between align-items-center mt-4-6">
                            <Col
                                md={4}
                                sm={4}
                                lg={4}
                                className="text-start"
                            >
                                <Breadcrumb>
                                    <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/" }}>
                                        Dashboard
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item linkAs={NavLink} linkProps={{ to: "/clients" }}>
                                        Clients
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item
                                        linkAs={NavLink}
                                        linkProps={{ to: `/clients/tax-forms/${client_id}` }}
                                    >
                                        Tax-Forms
                                    </Breadcrumb.Item>
                                    <Breadcrumb.Item linkAs={NavLink}
                                        linkProps={{ to: `/periods/${client_id}` }}>Shipping Bill Data</Breadcrumb.Item>
                                    <Breadcrumb.Item active>Files</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>

                            <Col
                                md={8}
                                sm={8}
                                lg={8}
                                className="d-flex justify-content-end align-items-center flex-wrap gap-3"
                            >
                                <div className="me-2">
                                    {/* {gridView === 'grid' && ( */}
                                    <div className="border btn-group btn-group-toggle" data-toggle="buttons">
                                        <label className={`btn ${filter === 0 ? 'btn-primary' : ''}`}>
                                            <input type="radio" onClick={() => handleFilterChange(0)} /> All
                                        </label>
                                        <label className={`btn ${filter === 1 ? 'btn-primary' : ''}`}>
                                            <input type="radio" onClick={() => handleFilterChange(1)} /> Processed
                                        </label>
                                        <label className={`btn ${filter === 2 ? 'btn-primary' : ''}`}>
                                            <input type="radio" onClick={() => handleFilterChange(2)} /> Failed
                                        </label>
                                    </div>
                                    {/* )} */}
                                </div>

                                {gridView === 'grid' && (
                                <div className="d-flex justify-content-center align-items-center me-2">
                                    <ViewSelector />
                                </div>
                                )}

                                {/* {uploadPermission && gridView !== 'egm' && ( */}
                                <div className="bg-success">
                                    <Button
                                        variant="primary"
                                        className="text-center d-flex align-items-center justify-content-center"
                                        onClick={open}
                                        title="Upload PDF files only"
                                    >
                                        <i className="ri-file-upload-line font-size-20 mr-1"></i>
                                        <h6 className="mb-0">Upload PDF</h6>
                                    </Button>
                                </div>
                                {/* )} */}
                            </Col>
                        </Row>

                        {/* Validation Alert */}
                        {validationAlert.show && (
                            <Row>
                                <Col md={12} className="justify-content-center d-flex">
                                    <Alert
                                        dismissible
                                        variant={validationAlert.type}
                                        onClose={() => setValidationAlert({ show: false, message: '', type: 'warning' })}
                                    >
                                        <p>{validationAlert.message}</p>
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        {/* Existing success/error alerts */}
                        {/* {(success || error) && (
                            <Row>
                                <Col
                                    md={12}
                                    className="justify-content-center d-flex"
                                >
                                    <Alert
                                        dismissible
                                        variant={success ? 'success' : 'danger'}
                                        onClose={() => dispatch(resetStore())}
                                    >
                                        <p>
                                            {success ? successMsg : error}
                                        </p>
                                    </Alert>
                                </Col>
                            </Row>
                        )} */}

                        <div {...getRootProps({ className: 'dropzonee' })}>
                            <input {...getInputProps()} />
                            <Row
                                style={{ display: gridView === 'grid' ? '' : 'none' }}
                                className="v-table "
                            >
                                {(!Array.isArray(data) || data.length === 0) && (<div className="d-flex justify-content-center align-items-center mt-4 fw-bold">No Files Uploaded Yet</div>)}
                                {Array.isArray(data) && data.map(file => {
                                    const { file_name, status, url, folder } = file;
                                    return (<PdfType
                                        className="v-icons mb-4 d-flex justify-content-between align-items-center"
                                        key={data.id}
                                        data={file}
                                        status={status}
                                        url={url}
                                        title={file_name}
                                        handleClick={handlePdfClick}
                                        handleDeleteFunc={(id) => handleDelete(id, folder)}
                                        showView={false}
                                        showDelete={true}
                                        showEdit={false}
                                    />)
                                })}
                            </Row>
                            <Row
                                style={{ display: gridView === 'list' ? '' : 'none' }}
                                className="v-table"
                            >
                                <Col>
                                    {(!Array.isArray(data) || data.length === 0) && (<div className="d-flex justify-content-center align-items-center mt-4 fw-bold">No Files Uploaded Yet</div>)}
                                    <ListView
                                        headers={TABLE_HEADERS}
                                        data={Array.isArray(data) ? data : []}
                                        handleDeleteFunc={(id) => handleDelete(id, folder_id)}
                                        showView={false}
                                        showDelete={true}
                                        showEdit={false}
                                        disableDeleteFunc={(file) => successStatusIcons.includes(file.status)}
                                    />
                                </Col>
                            </Row>

                            <Row
                                style={{ display: gridView === 'egm' ? '' : 'none' }}
                                className="v-table"
                            >
                                <Row className="mb-2">
                                    <Col
                                        md={5}
                                        lg={5}
                                        id="extenionconnectegmid"
                                    ></Col>
                                    <Col
                                        className="d-flex justify-content-end p-2"
                                    >
                                        <Button variant="primary" onClick={handleCloseEgmTable}>
                                            Close Table
                                        </Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <input type="hidden" name="nextbill" id="nextbill" value="" />
                                </Row>
                                {gridView === 'egm' && <Row>
                                    <Col>{Array.isArray(data) && !!data.length && <EgmTable
                                        headers={EGM_TABLE_HEADERS}
                                        data={data}
                                        handleSubmitFunc={handleEgmSubmit}
                                    />
                                    }
                                        {((Array.isArray(data) && !data.length) || (!Array.isArray(data))) && (<div className="d-flex justify-content-center align-items-center mb-5 fw-bold">No Processed Data available to Fetch Egm Data</div>)}
                                    </Col>
                                </Row>}
                            </Row>
                            <Row style={{ position: 'fixed', bottom: '20px', left: '60%', transform: 'translateX(-50%)', zIndex: 999 }}>
                                <Col md={12} className="d-flex justify-content-center">
                                    <PaginationComponent
                                        total_count={total_count}
                                        current_page={current_page}
                                        handleOnClick={handlePagination}
                                    />
                                </Col>
                            </Row>
                        </div>
                        <Modal size="xl" show={showPdf}>
                            <Modal.Header className="justify-content-end">
                                <Button variant="link" onClick={handleClose} className="p-0 m-0">
                                    <RiCloseLine size={24} color="#000" />
                                </Button>
                            </Modal.Header>
                            <Modal.Body >
                                <DocViewer
                                    className="doc-viewer"
                                    documents={pdfUrl}
                                    disableHeader
                                    pluginRenderers={[PDFRenderer]}
                                />
                            </Modal.Body>
                        </Modal>
                        <Modal show={upload_process_status === 1 && total_upload_file_count === (total_files_uploaded + total_files_uploaded_failed)}>
                            <Modal.Header>
                                <Modal.Title>Upload Summary</Modal.Title>
                            </Modal.Header>
                            <Modal.Body >
                                <Row>
                                    <Col md={6}>Successfull:</Col><Col md={6}>{total_files_uploaded}</Col>
                                    <Col md={6}>Failed:</Col><Col md={6}>{total_files_uploaded_failed}</Col>
                                </Row>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button onClick={handleSummaryClose}>
                                    OK
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </>
                )}
                <ImportDrawer onImport={handleImportResponse} folder_id={folder_id} gstrFormName="statement3" />
                {importedData && (
                    <FolderListModal
                        show={folderListModalOpen}
                        onHide={() => setFolderListModalOpen(false)}
                        client_id={client_id}
                        folder_id={folder_id}
                        data={importedData}
                        gstrFormName="statement3"
                        year={null}
                        month={null}
                        subCategories={null}
                        onSubmitSuccess={onSubmitSuccess}
                    />
                )}
            </Base>
        </BlockUi>
    )
}